export function deepClone(obj: any) {
    const cloneObj: any = {};
    for (const i in obj) {
        if (obj[i] instanceof Array) {
            cloneObj[i] = obj[i].map((item: any) => (item instanceof Object ? deepClone(item) : item));
        } else if (obj[i] instanceof Object) {
            cloneObj[i] = deepClone(obj[i]);
        } else {
            cloneObj[i] = obj[i];
        }
    }
    return cloneObj;
}
